<template>
  <svg width="6" height="6" viewBox="0 0 6 6">
    <g stroke="#3498db" stroke-linejoin="round">
      <circle cx="3" cy="3" r="2.5" fill="#fff"/>
    </g>
  </svg>
</template>
